import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=6df5ae3e&scoped=true"
import script from "./Place.vue?vue&type=script&lang=js"
export * from "./Place.vue?vue&type=script&lang=js"
import style0 from "./Place.vue?vue&type=style&index=0&id=6df5ae3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5ae3e",
  null
  
)

export default component.exports